import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import {
  GetJourneyForMessagesDocument,
  GetJourneyForMessagesQuery,
  GetJourneyForMessagesQueryVariables
} from "@typing/Generated";

const useUnreadMessagesCount = (journeyId: string) => {
  const getJourneyForMessagesQuery = useQuery<GetJourneyForMessagesQuery, GetJourneyForMessagesQueryVariables>(
    GetJourneyForMessagesDocument,
    {
      variables: {
        id: journeyId
      }
    }
  );

  const unreadMessageCountData = useMemo(() => {
    const unreadMessageCount = getJourneyForMessagesQuery.data?.journey.chats.reduce(
      (accumulator, chat) => accumulator + chat.unreadMessageCount,
      0
    );
    if (!unreadMessageCount) return {};

    // eslint-disable-next-line @typescript-eslint/naming-convention
    return { "data-unread": unreadMessageCount };
  }, [getJourneyForMessagesQuery.data?.journey.chats]);

  return unreadMessageCountData;
};

export default useUnreadMessagesCount;
